// Rails HTML auth (monolith) — sign-out and auth redirects use drip_backend.
// React reads the API host from REACT_APP_API_URL (must be `${drip_backend}/api/v1/`).

export const railsAuthBaseUrl = () => {
  const apiUrl = process.env.REACT_APP_API_URL
  if (!apiUrl) return ''

  try {
    return new URL(apiUrl).origin
  } catch {
    return ''
  }
}

export const railsSignOutUrl = () => {
  const base = railsAuthBaseUrl()
  if (!base) return null
  return `${base}/sign-out`
}

/** Rails Hotwire packaging page (merchant monolith). */
export const railsPackagingUrl = (jwt) => {
  const base = railsAuthBaseUrl()
  if (!base) return null
  if (!jwt) return `${base}/packaging`
  return `${base}/packaging?token=${encodeURIComponent(jwt)}`
}

/** Rails Hotwire products page (merchant monolith). */
export const railsProductsUrl = (jwt) => {
  const base = railsAuthBaseUrl()
  if (!base) return null
  if (!jwt) return `${base}/products`
  return `${base}/products?token=${encodeURIComponent(jwt)}`
}

/** Rails Hotwire custom labels page (merchant monolith). */
export const railsCustomLabelsUrl = (jwt) => {
  const base = railsAuthBaseUrl()
  if (!base) return null
  if (!jwt) return `${base}/custom-labels`
  return `${base}/custom-labels?token=${encodeURIComponent(jwt)}`
}

/** Rails Hotwire my custom products page (merchant monolith). */
export const railsCustomProductsUrl = (jwt) => {
  const base = railsAuthBaseUrl()
  if (!base) return null
  if (!jwt) return `${base}/my-custom-products`
  return `${base}/my-custom-products?token=${encodeURIComponent(jwt)}`
}

/** Rails Hotwire direct and bulk orders page (merchant monolith). */
export const railsBulkOrdersUrl = (jwt) => {
  const base = railsAuthBaseUrl()
  if (!base) return null
  if (!jwt) return `${base}/direct-and-bulk-orders`
  return `${base}/direct-and-bulk-orders?token=${encodeURIComponent(jwt)}`
}

/** Rails Hotwire orders page (merchant monolith). */
export const railsOrdersUrl = (jwt) => {
  const base = railsAuthBaseUrl()
  if (!base) return null
  if (!jwt) return `${base}/orders`
  return `${base}/orders?token=${encodeURIComponent(jwt)}`
}

/** Rails Hotwire invoices page (merchant monolith). */
export const railsInvoicesUrl = (jwt) => {
  const base = railsAuthBaseUrl()
  if (!base) return null
  if (!jwt) return `${base}/invoices`
  return `${base}/invoices?token=${encodeURIComponent(jwt)}`
}

/** Rails Hotwire get sales page (merchant monolith). */
export const railsGetSalesUrl = (jwt) => {
  const base = railsAuthBaseUrl()
  if (!base) return null
  if (!jwt) return `${base}/get-sales`
  return `${base}/get-sales?token=${encodeURIComponent(jwt)}`
}

/** Rails Hotwire store setup / turnkey purchase page (merchant monolith). */
export const railsStoreSetupUrl = (jwt) => {
  const base = railsAuthBaseUrl()
  if (!base) return null
  if (!jwt) return `${base}/purchase-turnkey-store`
  return `${base}/purchase-turnkey-store?token=${encodeURIComponent(jwt)}`
}

/** Rails Hotwire creative services page (merchant monolith). */
export const railsCreativeServicesUrl = (jwt) => {
  const base = railsAuthBaseUrl()
  if (!base) return null
  if (!jwt) return `${base}/creative-services`
  return `${base}/creative-services?token=${encodeURIComponent(jwt)}`
}

/** Rails Hotwire media packages page (merchant monolith). */
export const railsMediaPackagesUrl = (jwt) => {
  const base = railsAuthBaseUrl()
  if (!base) return null
  if (!jwt) return `${base}/purchase-media-packages`
  return `${base}/purchase-media-packages?token=${encodeURIComponent(jwt)}`
}

/** Rails Hotwire media packages history page (merchant monolith). */
export const railsMediaPackagesHistoryUrl = (jwt) => {
  const base = railsAuthBaseUrl()
  if (!base) return null
  if (!jwt) return `${base}/media-packages-history`
  return `${base}/media-packages-history?token=${encodeURIComponent(jwt)}`
}

/** Rails Hotwire settings page (merchant monolith). */
export const railsSettingsUrl = (jwt, search = '') => {
  const base = railsAuthBaseUrl()
  if (!base) return null

  const params = new URLSearchParams(
    typeof search === 'string' ? search.replace(/^\?/, '') : '',
  )
  if (jwt && !params.has('token')) {
    params.set('token', jwt)
  }
  const qs = params.toString()
  return `${base}/settings${qs ? `?${qs}` : ''}`
}

/** Build a Rails merchant page URL for any migrated path (preserves query + JWT). */
export const railsMerchantPageUrl = (pathname, jwt, search = '') => {
  const base = railsAuthBaseUrl()
  if (!base || !pathname) return null

  const params = new URLSearchParams(
    typeof search === 'string' ? search.replace(/^\?/, '') : '',
  )
  if (jwt && !params.has('token')) {
    params.set('token', jwt)
  }
  const qs = params.toString()
  return `${base}${pathname}${qs ? `?${qs}` : ''}`
}

/** Clear React token storage and end Rails monolith session (GET /sign-out). */
export const performSignOut = (clearStorageFn, deleteCookieFn) => {
  clearStorageFn()
  deleteCookieFn()

  const signOutUrl = railsSignOutUrl()
  if (signOutUrl) {
    window.location.href = signOutUrl
    return
  }

  window.location.reload()
}
